document.addEventListener('DOMContentLoaded', () => {
  const modal    = document.getElementById('lightboxModal')
  const img      = document.getElementById('lightboxImg') as HTMLImageElement | null
  const caption  = document.getElementById('lightboxCaption')
  const closeBtn = document.getElementById('lightboxClose')
  const backdrop = document.getElementById('lightboxBackdrop')
  const prevBtn  = document.getElementById('lightboxPrev')
  const nextBtn  = document.getElementById('lightboxNext')

  if (!modal || !img) return

  let current = 0

  // Always queries the DOM at call time — picks up dynamically added photos
  const getLinks = (): HTMLAnchorElement[] =>
    Array.from(document.querySelectorAll<HTMLAnchorElement>('.galeria-link'))

  const open = (index: number) => {
    const links = getLinks()
    current = index
    const link = links[index]
    if (!link) return

    img.src = link.getAttribute('href') ?? ''
    img.alt = link.dataset.title ?? ''
    if (caption) caption.textContent = link.dataset.title ?? ''

    modal.classList.add('open')
    modal.setAttribute('aria-hidden', 'false')
    document.body.style.overflow = 'hidden'
  }

  const close = () => {
    modal.classList.remove('open')
    modal.setAttribute('aria-hidden', 'true')
    document.body.style.overflow = ''
    setTimeout(() => { img.src = '' }, 300)
  }

  const prev = () => {
    const links = getLinks()
    open((current - 1 + links.length) % links.length)
  }

  const next = () => {
    const links = getLinks()
    open((current + 1) % links.length)
  }

  // Event delegation — works for both initial and AJAX-loaded items
  document.addEventListener('click', (e) => {
    const link = (e.target as Element).closest<HTMLAnchorElement>('.galeria-link')
    if (!link) return
    e.preventDefault()
    const links = getLinks()
    const index = links.indexOf(link)
    if (index >= 0) open(index)
  })

  closeBtn?.addEventListener('click', close)
  backdrop?.addEventListener('click', close)
  prevBtn?.addEventListener('click', prev)
  nextBtn?.addEventListener('click', next)

  document.addEventListener('keydown', (e) => {
    if (!modal.classList.contains('open')) return
    if (e.key === 'Escape')    close()
    if (e.key === 'ArrowLeft') prev()
    if (e.key === 'ArrowRight') next()
  })
})
